import Sidebar from '../components/layout/Sidebar';
import Header from '../components/layout/Header';
import { ExecBilling } from '../components/widgets/ExecBilling/ExecBilling';

export default function ExecBillingPage() {
  return (
    <div className="flex h-screen bg-gray-50">
      <Sidebar />
      <div className="flex-1 flex flex-col overflow-hidden">
        <Header title="הנהלת חשבונות · אישור ותשלום" />
        <main className="flex-1 overflow-y-auto p-6">
          <ExecBilling />
        </main>
      </div>
    </div>
  );
}
